import { css, Stack, styled } from '@mui/material';

export const SContainer = styled(Stack)(
  () => css`
    align-items: center;
    width: 100%;
    gap: 2px;
  `,
);

export const STextContainer = styled(Stack)(
  () => css`
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  `,
);
